import { create } from 'zustand'

type InviteRedirectState = {
  errorMessage: string | null
  setErrorMessage: (message: string) => void
  clearErrorMessage: () => void
}

export const useInviteRedirectStore = create<InviteRedirectState>((set) => ({
  errorMessage: null,
  setErrorMessage: (message) => set({ errorMessage: message }),
  clearErrorMessage: () => set({ errorMessage: null }),
}))
